export default "__VITE_ASSET__53347e64__"